import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalContextProvider } from "./GlobalContext";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { LicenseInfo } from '@mui/x-license';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './Redux/store';

LicenseInfo.setLicenseKey('e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y');

const isUnsupportedFcmError = (message?: string) => {
  if (!message) return false;
  return (
    message.includes("messaging/unsupported-browser") ||
    message.includes("Messaging: This browser doesn't support the API's required to use the Firebase SDK")
  );
};

window.addEventListener('error', (event) => {
  const message = String(event.error?.message || event.message || '');
  if (isUnsupportedFcmError(message)) {
    event.preventDefault();
    console.warn('[FCM] Suppressed unsupported-browser error:', message);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message = typeof reason === 'string' ? reason : String(reason?.message || '');
  if (isUnsupportedFcmError(message)) {
    event.preventDefault();
    console.warn('[FCM] Suppressed unsupported-browser rejection:', message);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <GlobalContextProvider>
            <App />
          </GlobalContextProvider>
        </Router>
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();